module.exports = __webpack_public_path__ + "media/10.743865d5.mp3";